<template>
  <div class="zhaoping-classroom-subsection">
    <div class="classroom-a" v-anim="'animate__fadeInUp'" style="animation-delay:0.2s">
      <div class="classroom-a-inner">
        <div class="label-rect"></div>
        <div class="label-text">教室</div>
      </div>
    </div>
    <div class="classroom-b" v-anim="'animate__fadeInUp'" style="animation-delay:0.3s">
      <img class="classroom-b-img" alt="Classroom" src="/static/img/zhaoping-mask-group-41.jpg" loading="lazy" />
      <div class="label-rect-b"></div>
      <div class="label-text-b">教室</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ZhaopingClassroomSubsection",
  directives: {
    anim: {
      inserted(el, binding) {
        const cls = binding && binding.value ? binding.value : "animate__fadeInUp";
        el.classList.add("animate__animated");
        const io = new IntersectionObserver(
          (entries) => {
            entries.forEach((e) => {
              if (e.isIntersecting) {
                el.classList.add(cls);
                io.unobserve(el);
              }
            });
          },
          { threshold: 0.2 }
        );
        io.observe(el);
      },
    },
  },
};
</script>

<style scoped>
.zhaoping-classroom-subsection { position: absolute; left: 0; top: 3004px; width: 1920px; height: 473px; }
.classroom-a { background-color: #e1e1e1; background-image: url(/static/img/zhaoping-mask-group-31.jpg); background-size: 100% 100%; border-radius: 15px; display: flex; height: 473px; left: 513px; position: absolute; top: 0; width: 813px; }
.classroom-a-inner { height: 58px; margin-top: 351px; position: relative; width: 210px; }
.label-rect { background: linear-gradient(90deg, rgba(1,92,211,1) 0%, rgba(0,55,138,0) 100%); height: 58px; left: 0; position: absolute; top: 0; width: 208px; }
.label-text { align-items: center; color: #ffffff; display: flex; font-family: "PingFang SC-Regular", Helvetica; font-size: 24px; font-weight: 400; height: 30px; justify-content: center; left: 32px; letter-spacing: 0; line-height: 30px; position: absolute; top: 14px; white-space: nowrap; }
.classroom-b { background-color: #e1e1e1; border-radius: 15px; height: 473px; left: 1386px; position: absolute; top: 0; width: 813px; }
.classroom-b-img { height: 473px; left: 0; position: absolute; top: 0; width: 534px; object-fit: cover; }
.label-rect-b { background: linear-gradient(90deg, rgba(1,92,211,1) 0%, rgba(0,55,138,0) 100%); height: 58px; left: 0; position: absolute; top: 351px; width: 208px; }
.label-text-b { align-items: center; color: #ffffff; display: flex; font-family: "PingFang SC-Regular", Helvetica; font-size: 24px; font-weight: 400; height: 30px; justify-content: center; left: 32px; letter-spacing: 0; line-height: 30px; position: absolute; top: 365px; white-space: nowrap; }
</style>
